import Ajv from "ajv";

import { lvtResponseSchema } from "../common";


const videoRetrievalSchema = {
    type: "number",
};

export const videoRetrievalValidator = new Ajv().compile(videoRetrievalSchema);

const lvtResponseVideoRetrievalSchema = lvtResponseSchema(videoRetrievalSchema);

// TODO: actually do this
export const lvtResponseVideoRetrievalValidator = new Ajv().compile(lvtResponseVideoRetrievalSchema);
